var _circle, _path, _path2, _path3, _path4, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg1F602(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#FFDD67",
    cx: 32,
    cy: 32,
    r: 30
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#664E27",
    d: "M49.696 34.436c-.406-.52-1.127-.43-1.912-.43H16.216c-.785 0-1.505-.09-1.912.43C10.394 39.422 14.994 54 32 54c17.007 0 21.606-14.578 17.696-19.564z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#4C3526",
    d: "M33.843 41.74c-.578-.014-1.47.527-1.144 1.957.163.723 1.19 1.598 1.19 2.764 0 2.371-3.777 2.371-3.777 0 0-1.166 1.025-2.041 1.19-2.764.326-1.43-.565-1.971-1.145-1.957-1.571.041-4.149 1.736-4.149 4.605 0 3.223 2.684 5.836 5.992 5.836 3.307 0 5.99-2.613 5.99-5.836.001-2.868-2.577-4.564-4.147-4.605z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF717F",
    d: "M24.287 50.664c2.229.957 4.8 1.518 7.713 1.518 2.914 0 5.484-.561 7.713-1.518-2.15-1.031-4.711-1.662-7.713-1.662s-5.561.631-7.713 1.662z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M46.954 36H17.047c-2.053 0-2.053 4-.053 4h30.013c2 0 2-4-.053-4z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#65B1EF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.44 36.874c7.307 7.679-2.621 18.116-9.93 10.437-5.336-5.611-5.578-16.301-5.578-16.301s10.174.257 15.508 5.864zM14.488 47.311C7.183 54.99-2.749 44.553 4.56 36.874c5.336-5.608 15.508-5.864 15.508-5.864s-.244 10.693-5.58 16.301z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#664E27"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.526 28.669C26.667 23.558 23.866 21 21.065 21s-5.602 2.558-7.46 7.669c-.184.515.774 1.443 1.254.938 1.802-1.901 3.957-2.658 6.206-2.658 2.25 0 4.405.757 6.207 2.658.478.505 1.438-.423 1.254-.938zM50.396 28.669C48.536 23.558 45.735 21 42.935 21s-5.602 2.558-7.461 7.669c-.184.515.775 1.443 1.254.938 1.803-1.901 3.957-2.658 6.207-2.658s4.404.757 6.207 2.658c.478.505 1.437-.423 1.254-.938z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1F602);
export default __webpack_public_path__ + "static/media/1f602.87a7abd515799b56d8722c9f9d20ff1a.svg";
export { ForwardRef as ReactComponent };